import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FiGlobe } from "react-icons/fi";

const Language = () => {
  const [open, setOpen] = useState(false);
  const { i18n } = useTranslation();

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    setOpen(false);
  };

  return (
    <div className="relative inline-block">
      <button
        onClick={() => setOpen(!open)}
        className="p-2 rounded-full transition-all duration-300 border-transparent hover:shadow-md border hover:border-light active:scale-95"
      >
        <FiGlobe className="w-6 h-6 text-light" />
      </button>

      {open && (
        <div className="absolute z-10 left-1/2 -translate-x-1/2 mt-2 bg-dark rounded-lg shadow-lg overflow-hidden">
          <button
            onClick={() => changeLang("ka")}
            className="w-full text-left px-4 py-2 transition-all duration-300 hover:bg-light/50"
          >
            🇬🇪
          </button>

          <button
            onClick={() => changeLang("en")}
            className="w-full text-left px-4 py-2 transition-all duration-300 hover:bg-light/50"
          >
            🇬🇧
          </button>
        </div>
      )}
    </div>
  );
};

export default Language;
